<template>
  <div class="iframe-container-box container">
    <div class="header">
      <rs-row>
        <rs-col :span="24">
          <div class="grid-content bg-purple-dark">
            <span style="margin-left: 10px">缴费信息</span>
          </div></rs-col
        >
      </rs-row>
    </div>
    <div class="main">
    
    <rs-row style=" min-height: 600px">
      <div class="main_header">
        
      
      <div class="searchForm" style="margin-top:10px">
        <renderForm
          :list="ruleForm"
          size="small"
          :formData.sync="searchForm"
          ref="ruleFormRef"
        >
        <rs-form-item label="合同号" slot="mallName" >
        <rs-select  v-model="searchForm.contractCode" placeholder="请选择">
    <rs-option
      v-for="item in Contract" :key='item.value'
      :label="item"
      :value="item">
    </rs-option>
  </rs-select>
      </rs-form-item>
       <rs-form-item label="缴费日期" slot="date" >
       <rs-date-picker
        v-model="searchForm.beginDate "
        type="daterange"
        range-separator="-"
        start-placeholder="开始时间"
        :default-value="timeDefaultShow"
        end-placeholder="结束时间"
        size="mini"
        class="margin-right-10">
      </rs-date-picker>
      </rs-form-item>
        </renderForm>
        <div style="margin-left: 50%; position: relative; top: -45px">
          <rs-button
            type="primary"
            style="margin-left: 45px"
            size="small"
            @click="handleSearch"
            >查询</rs-button
          >
          <rs-button type="text" size="small" @click="clear"
            >重置</rs-button
          >
        </div>
      </div>
      <div class="contractCode">
        <div>
          <div>待缴总金额（元）</div>
          <div class="contractCodecolor">{{ amountpaid }} <span></span></div>
        </div>
        <div>
          <div>当期缴费金额(元)</div>
          <div>{{ Currentnumber }} <span></span></div>
        </div>
        <div>
          <div>已缴总金额（元）</div>
          <div>{{ PaidAmount }} <span></span></div>
        </div>
        <div>
          <div>缴费记录</div>
          <div>{{PayNum}}</div>
        </div>
      </div>
   </div>
   <div class="main_main" style="background: #fff; box-shadow: 2px 2px 10px #909090;">
      <rs-row :gutter="24" style="height: 2%;margin-top:20px;padding:10px;padding-top:50px">
     
        <rs-col :span="12">
          <rs-row>
            <rs-button size="mini" :type="primaryButton" @click="wholeReception"
              >待缴账单</rs-button
            >
            <rs-button size="mini" :type="primary" @click="wholeRecep"
              >已缴账单</rs-button
            >
            <rs-button
              size="mini"
              :type="primaryliushui"
              @click="wholeRecepliushui"
              >缴费流水</rs-button
            >
          </rs-row>
        </rs-col>
        <rs-col :span="11" :offset="1">
          <rs-button style="float: right; margin-left: 4%" plain
            @click="export2Excel"
            >下载</rs-button
          >
          <rs-button style="float: right" type="primary" @click="confirmation()"
            >缴费确认</rs-button
          >
        </rs-col>
      </rs-row>

      <!-- 操作栏 -->
      <div class="operBox"></div>
      <!-- 表格 -->
      <div class="resultContent" style="margin-top: -45px">
        <renderTable
        style="padding:10px"
          class="row-click"
          :list="tableData"
          :columns="tableColumns"
          border
          ref="multipleTable"
          @row-dblclick="handleView"
          @selection-change="handleSelectionChange"
        >
          <rs-table-column type="selection" width="155px"> </rs-table-column>

          <rs-table-column
            label="合同号"
            slot="contractCode"
            sortable
            width="160px"
          >
            <template slot-scope="scope">
              <span
                @dbclick.stop="toDetails(scope.row.id)"
                style="cursor: pointer"
                >{{ scope.row.contractCode }}</span
              >
            </template>
          </rs-table-column>

          <rs-table-column
            label="铺位号"
            slot="boothCode"
            width="160px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.boothList" :key="index">
                <span v-if="index != 0">|</span>
                {{ item.boothCode }}
              </span>
            </template>
          </rs-table-column>

          <rs-table-column label="店铺名称" slot="shopName" width="160px">
            <template slot-scope="scope">
              {{ scope.row.shopName }}
            </template>
          </rs-table-column>

          <rs-table-column
            label="操作"
            slot="operation"
            fixed="right"
            width="240px"
          >
            <template slot-scope="scope"> </template>
          </rs-table-column>
        </renderTable>

        <!-- 分页 -->
        <rs-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 200, 300, 400]"
          :page-size="pageSize"
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          layout="total,prev, pager, next, sizes, jumper"
          :total="total"
        ></rs-pagination>
      </div>
</div>
      <rs-dialog title="确认" :visible.sync="dialogVisible" width="30%">
        <h2 style="text-align: center; margin: 0">
          {{ `确认${confirmType}吗？` }}
        </h2>
        <span slot="footer" class="dialog-footer">
          <rs-button @click="dialogVisible = false">取 消</rs-button>
          <rs-button type="primary" @click="confirm">确 定</rs-button>
        </span>
      </rs-dialog>
      <change-type-dialog
        :path="path"
        :contractId="contractId"
        :dialogVisible="showChangeTypeDialog"
        @close="
          () => {
            this.showChangeTypeDialog = false;
          }
        "
      >
      </change-type-dialog>
    </rs-row>
      
    </div>
  </div>
</template>

<script>
	import Export2Excel from '@/utils/Export2Excel';
  	import Blob from '@/utils/Blob';
import Http from "@/api/api";
import API from "@/api/pay";
import utils from "@/utils/utils";
// import detail from "../resourceManage/resourceDetail";
export default {
  name: "resourceManage",
  // components: { detail },
  data() {
    return {
      PayNum:0,
      primaryButton: "primary",
      primary: "",
      primaryliushui: "",
      timeDefaultShow:[],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      showChangeTypeDialog: false,
      path: "",
      contractId: "",
      tableData: [],
        Contract:[],
      // wholeReceptiontabData: [],
      // wholeRecepData: [],
      // wholeRecepliushuiData: [],
      // tableColumns: [],

      // ruleForm: [],
      // tmpRuleForm: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        contractCode: "",
        beginDate: [],
        shopId: "",
      },
      searchFormClose: true,
      amountpaid: "",
      confirmType: "",
      dialogVisible: false,
      shopVo: {},
      updateTime: "",
      Currentnumber: "",
      PaidAmount:0,
      categoryList: [],
	  val:''
    };
  },
  watch: {
    searchMenuName(val) {
      console.log(val);
      this.$refs.resourceTree.filter(val);
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
	  this.bus.$on('val',(val)=>{
		  this.val=val
	  })
    // this.getTime()
    this.shopVo = sessionStorage.getItem("shopVo");
    // debugger
    let { auditStatusStr, mallCode } = this.$route.query;
    this.searchForm.auditStatusStr = auditStatusStr ? [1 * auditStatusStr] : [];
    this.searchForm.mallCode = mallCode || "";
    this.renderPage();
    if (
      this.$route.query.mallCode &&
      this.$route.query.contractStatus &&
      this.$route.query.days
    ) {
      this.searchForm.contractStatusStr = Number(
        this.$route.query.contractStatus
      );
      this.searchForm.auditStatusStr = 2; //审核通过
      this.searchForm.mallCode = this.$route.query.mallCode;
      let days = Number(this.$route.query.days);
      if (this.$route.query.contractStatus == 4) {
        //待生效==查近期开始合同
        this.searchForm.beginDate =
          days > 0
            ? [utils.dateFormatter(new Date()), this.getAfterParamsDate(days)]
            : [this.getAfterParamsDate(days), utils.dateFormatter(new Date())];
      } else if (this.$route.query.contractStatus == 1) {
        //已生效==查近期到期合同
        this.searchForm.endDates =
          days > 0
            ? [utils.dateFormatter(new Date()), this.getAfterParamsDate(days)]
            : [this.getAfterParamsDate(days), utils.dateFormatter(new Date())];
      }
    }
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.handleQuery();
    this.amountobepaid();
    this.Currentpayment();
    this.TotalPaidAmount();
  },
  activated() {
    this.handleQuery();
  },
  methods: {
      getTime(){
 let d=new Date();
let n=d.toLocaleDateString();
  this.timeDefaultShow.push(n)
  this.timeDefaultShow.push(n)
  console.log(this.timeDefaultShow)
},

    // toDetails(id) {
    //   this.$openTabSwitch(
    //     "合同详情",
    //     `/contractNew?actionType=view&contractType=${this.contractType}&contractId=${id}&fromPath=versionList`
    //   );
    // },

    //待缴账单
    wholeReception(e) {
        console.log(e.target.innerHTML)
      localStorage.setItem('index',e.target.innerHTML)
      this.primaryButton = "primary";
      this.primary = "";
      this.primaryliushui = "";
      //待缴账单
      this.Bills();
      // this.tableData = this.wholeReceptiontabData;
    },
    //已缴账单
    wholeRecep(e) {
        console.log(e.target.innerHTML)
      localStorage.setItem('index',e.target.innerHTML)
      this.primaryButton = "";
      this.primary = "primary";
      this.primaryliushui = "";
      //已缴账单
      this.getTotalPaidAmount();
      // this.tableData = this.wholeRecepData;
    },
    //缴费流水
    wholeRecepliushui(e) {
        console.log(e.target.innerHTML)
      localStorage.setItem('index',e.target.innerHTML)
      this.primaryButton = "";
      this.primary = "";
      this.primaryliushui = "primary";
      //缴费流水
      this.getPayRecordList();
      // this.tableData = this.wholeRecepliushuiData;
    },
    //下载生成excel
    	formatJson(filterVal, jsonData) {
				return jsonData.map((v) => filterVal.map((j) => v[j]));
			},
    			export2Excel() {
			    require.ensure([], () => {
			         const { export_json_to_excel } = require('../../../utils/Export2Excel');
			         const tHeader = [ '铺位号', '楼栋', '楼层','账单周期', '账单应收日', '应收金额', '费用项','合同号'];
			        const filterVal = [ 'boothCode', 'buildingName', 'floorName','statementBeginEndTime', 'paymentDue', 'receivableAmount', 'itemName','contractCode'];
			        const list = this.tableData;
			        console.log( list)
			        const data = this.formatJson(filterVal, list);
			        export_json_to_excel(tHeader, data, '缴费信息表');
			    });
			},

    //

    getAfterParamsDate(params) {
      let date = new Date().getTime() + 24 * 60 * 60 * 1000 * params;
      date = utils.dateFormatter(date);
      return date;
    },
    // 查询
    handleSearch() {
      this.pageNum = 1;
      console.log(this.searchForm);
      if(localStorage.getItem('index')=='待缴账单'){
      this.handleQuery();
      }else if(localStorage.getItem('index')=='已缴账单'){
        this.getTotalPaidAmount()
      }else{
this.getPayRecordList()
      }
    },
    clear() {
      this.searchForm = {
        businessId: "",
        contractCode: "",
        beginDate: [],
      };
    },
    // 列表API数据
    handleQuery() {
      let pageNum = this.pageNum;
      let pageSize = this.pageSize;
      // console.log(this.searchForm, "kanakn");
      let params = {
        pageSize,
        pageNum,
        ...this.searchForm,
        paidStatus: 0,
        shopId: this.shopVo,
      };
      params = this.turnParams(params);
      API.page(params)
        .then((res) => {
          if (res.data.code == 200) {
            console.log("获取合同列表", res);
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
             for(var i=0;i<this.tableData.length;i++){
                 if(this.Contract.indexOf(this.tableData[i].contractCode)===-1){
                   this.Contract.push(this.tableData[i].contractCode)
                 }
            }
          }
        })
        .finally(() => {
          utils.hideLoading();
        });
    },
    turnParams(params) {
      console.log(params);
      if (params.beginDate && params.beginDate.length) {
        params.paymentDueBeginDate =
          typeof params.beginDate[0] == "object"
            ? utils.dateFormatter(params.beginDate[0], "yyyy-MM-dd")
            : params.beginDate[0];
        params.paymentDueEndDate =
          typeof params.beginDate[1] == "object"
            ? utils.dateFormatter(
                typeof params.beginDate[1] == "object"
                  ? params.beginDate[1]
                  : new Date(params.beginDate[1]),
                "yyyy-MM-dd"
              )
            : params.beginDate[1];
      } else {
        params.paymentDueBeginDate = "";
        params.paymentDueEndDate = "";
      }
      delete params.beginDate;
      if (params.endDates && params.endDates.length) {
        params.beginDate =
          typeof params.endDates[0] == "object"
            ? utils.dateFormatter(params.endDates[0], "yyyy-MM-dd")
            : params.endDates[0];
        params.endDate =
          typeof params.endDates[1] == "object"
            ? utils.dateFormatter(params.endDates[1], "yyyy-MM-dd")
            : params.endDates[1];
      } else {
        params.beginDate = "";
        params.endDate = "";
      }
      delete params.endDates;
      console.log(params);
      return params;
    },

    //获取已缴费清单
    getTotalPaidAmount() {
      let pageNum = this.pageNum;
      let pageSize = this.pageSize;
      console.log(this.shopVo);
      // console.log(this.shopVo.shopId)
      // console.log(this.searchForm, "kanakn");
      let params = {
        pageSize,
        pageNum,
        ...this.searchForm,
        paidStatus: 1,
        businessId: this.shopVo,
      };
      // params = this.turnParams(params);
      API.page(params)
        .then((res) => {
          if (res.data.code == 200) {
            console.log("获取合同列表", res);
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
              
          }
        })
        .finally(() => {
          utils.hideLoading();
        });
    },

    //获取未缴费清单  （未缴费加上一个月时间）
    Bills() {
      let pageNum = this.pageNum;
      let pageSize = this.pageSize;
      console.log(this.shopVo);
      console.log(this.shopVo.shopId);
      // console.log(this.searchForm, "kanakn");
      let params = {
        pageSize,
        pageNum,
        ...this.searchForm,
        // businessId: this.shopVo,
        shopId: this.shopVo,
        // paidStatus:0,
      };
      // params = this.turnParams(params);
      API.page(params)
        .then((res) => {
          if (res.data.code == 200) {
            console.log("获取合同列表", res);
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
          }
        })
        .finally(() => {
          utils.hideLoading();
        });
    },

    //缴费流水
    getPayRecordList() {
      let pageNum = this.pageNum;
      let pageSize = this.pageSize;
      console.log(this.shopVo.shopId);
      // console.log(this.searchForm, "kanakn");
      let params = {
        pageSize,
        pageNum,
        ...this.searchForm,
        paidStatus: 0,
        businessId: this.shopVo,
      };
      // params = this.turnParams(params);
      API.getPayRecordList(params)
        .then((res) => {
          if (res.data.code == 200) {
            console.log("获取合同列表", res);
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
          
          }
        })
        .finally(() => {
          utils.hideLoading();
        });
    },

    //获取待缴费金额
    amountobepaid() {
      let params = {
        businessId: this.shopVo,
        paymentDueBeginDate: "",
        paymentDueEndDate: "",
        contractCode: this.searchForm.contractCode,
      };

      API.paygetTotalUnpaidAmount(params).then((res) => {
        if (res.data.code == 200) {
          console.log("获取合同列表11111", res);
          this.amountpaid = res.data.data;
        }
      });
    },

    addDate() {
      // const nowDate = new Date();
      // const date = {
      //   year: nowDate.getFullYear(),
      //   month: nowDate.getMonth() + 2,
      //   date: nowDate.getDate(),
      // };
      // const newmonth = date.month > 10 ? date.month : "0" + date.month;
      // const day = date.date > 10 ? date.date : "0" + date.date;
      // const hh = new Date().getHours();
		  // const mf = new Date().getMinutes()
		  // const ss = new Date().getSeconds()
       var _this = this;
		      // let yy = new Date().getFullYear();
		      // let mm = new Date().getMonth()+1;
		      // let dd = new Date().getDate();
		      // let hh = new Date().getHours();
		      // let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
		      // let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
          var d = new Date();
          var ye = d.getFullYear();
          var mo = (d.getMonth()+1).toString().padStart(2,'0');
          var da = d.getDate().toString().padStart(2,'0');
          var updateTime = ye+'-'+mo+'-'+da;
          // alert(time);
		      // _this.updateTime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
          _this.updateTime = updateTime
		      console.log(updateTime)


      // this.updateTime = date.year + "-" + newmonth + "-" + day + '' + hh;
    },

    //获取当期缴费金额   当前时间加一个月
    Currentpayment() {
      this.addDate();
      let updateTime = this.updateTime;
      console.log(updateTime);
      // let time = Number(updateTime)
      // console.log(time)
      let params = {
        businessId: this.shopVo,
        paymentDueBeginDate: "",
        paymentDueEndDate: '2021-06-01',
        contractCode: this.searchForm.contractCode,
      };

      API.paygetTotalUnpaidAmount(params).then((res) => {
        if (res.data.code == 200) {
          console.log("获取合同列表", res);
          this.Currentnumber = res.data.data;
        }
      });
    },

    //获取已缴费金额
    TotalPaidAmount() {
      let params = {
        ...this.searchForm,
        // paidStatus: 0,
        businessId: this.shopVo,
      };

      API.getTotalPaidAmount(params).then((res) => {
        if (res.data.code == 200) {
          console.log("获取合同列表", res);
          if(res.data.data==null){
            this.PaidAmount=0
          }else{
  this.PaidAmount = res.data.data;
          }
        
        }
      });
    },

    //获取
    handleSelectionChange(val) {
		this.bus.$emit('val',val)
      this.multipleSelection = val;
      console.log(this.multipleSelection);
      var categorystr = "";
      var classifystr = "";
      var classirerstr = "";
      this.multipleSelection.forEach(function (c) {
        categorystr += c.statementNo + ",";
        classifystr += c.itemCode + ",";
        classirerstr += c.businessId + ",";
      });
      categorystr = categorystr.substring(0, categorystr.length - 1);
      console.log(categorystr);
      classifystr = classifystr.substring(0, classifystr.length - 1);
      classirerstr = classirerstr.substring(0, classirerstr.length - 1);
      // this.categoryList = categorystr.split(",");
      // this.classifystr = classifystr.split(",");
      // this.classirerslist = classirerstr.split(",");
      this.categoryList = categorystr;
      this.classifystr = classifystr;
      this.classirerslist = classirerstr;
      // console.log(str)
      console.log(this.categoryList);
      console.log(this.classifystr);
      console.log(this.classirerslist);
    },

    //缴费确认
    confirmation() {
		if(this.val.length==0){
			this.$message.error('您还未勾选需要缴费的信息')
		}else{
			let params = {
			  statementNo: this.categoryList,
			  itemCode: this.classifystr,
			  businessId: "407",
			};
			console.log(params)
			API.unifiedPreOrder7011(params).then((res) => {
			  if (res.data.code == 200) {
			    console.log("获取合同列表", res);
			
			    window.open(res.data.data.pc_cashier_url);
			    let params = {
			      merOrderNo: res.data.data.merOrderNo,
			    };
			    API.getPayRecordByMerOrderNo(params).then((res) => {
			      if (res.data.code == 200) {
			        console.log("获取合同列表", res);
			
			      } 
			    });
			  } else {
			  }
			});
		}
     
    },

    // 查看
    handleView(row) {
      console.log(row);
      // if (!this.$btnResource()["zyht-ck"]) {
      //   this.$message.warning("暂无查看权限");
      //   return;
      // }
      // this.$openTabSwitch(
      //   "自营合同详情",
      //   `/contractNew?actionType=view&contractType=norm&contractId=${row.id}&fromPath=contractList`
      // );
      // this.$router.push({path: '/contract', query: {actionType:'view',contractType:'norm',contractId:row.id}})
    },
    // 历史版本
    // toVersion(scope) {
    //   this.$openTabSwitch(
    //     "自营合同历史版本",
    //     `/versionList?contractType=norm&contractCode=${scope.row.contractCode}&fromPath=contractList`
    //   );
    // },
    // 退租
    // toTuizu(scope) {
    //   this.$openTabSwitch(
    //     "自营合同退租",
    //     `/tuizu?contractType=norm&contractCode=${scope.row.contractCode}&fromPath=contractList&id=${scope.row.id}`
    //   );
    // },
    // 合同终止
    // toStop(scope) {
    //   let { id } = scope.row;
    //   this.$openTabSwitch(
    //     "自营合同终止",
    //     `/refundEdit?contractId=${id}&jumpType=add`
    //   );
    // },
    // 新增
    // handleCreate(scope, actionType, typeName) {
    //   let id = scope ? scope.row.id : "",
    //     contractCode = scope ? scope.row.contractCode : "";
    //   let title = `${typeName}自营合同`;
    //   if (actionType == "renew") {
    //     this.$openTabSwitch(
    //       title,
    //       `/contractNew?actionType=${actionType}&contractType=norm&contractId=${id}&correlationContractId=${id}&correlationContractCode=${contractCode}`
    //     );
    //   } else if (actionType == "stop") {
    //     this.$openTabSwitch(
    //       title,
    //       `/contractNew?actionType=${actionType}&contractType=norm&contractId=${id}&correlationContractId=${id}&correlationContractCode=${contractCode}`
    //     );
    //   } else {
    //     this.$openTabSwitch(
    //       title,
    //       `/contractNew?actionType=${actionType}&contractType=norm&contractId=${id}`
    //     );
    //   }
    // },
    // 审核
    // toApply(flowNo) {
    //   this.$getZjBpmViewUrl(flowNo);
    //   // this.$openTabSwitch2(
    //   //   "",
    //   //   `/workflow/#/flowDetail?processInstanceId=${id}&isBack=true`
    //   // );
    // },
    // 删除  作废
    // openDialog(scope, type) {
    //   this.contractId = scope.row.id;
    //   this.confirmType = type;
    //   this.dialogVisible = true;
    // },
    // 删除  作废  confirm
    async confirm() {
      let res = null;
      if (this.confirmType == "删除") {
        res = await API.delete({ id: this.contractId });
      } else if (this.confirmType == "作废") {
        res = await API.cancel({ id: this.contractId });
      }
      if (res.data.code == 200) {
        this.dialogVisible = false;
        this.handleQuery();
        this.$message.success(`${this.confirmType}成功`);
      }
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.handleQuery();
    },
    changeSearchFormClose() {
      this.searchFormClose = !this.searchFormClose;
      if (this.searchFormClose) {
        this.ruleForm = this.ruleForm.filter((item) => {
          return !item.allowHide;
        });
      } else {
        this.ruleForm = this.tmpRuleForm;
      }
    },
    mallChange(val) {
      // console.log(val )
      this.$set(this.searchForm, "mallCode", val.mallCode);
      this.$set(this.searchForm, "mallName", val.mallName);
      this.handleQuery();
    },
    changeFloor(val) {
      // console.log(val);
      this.searchForm.buildingId = _.uniq(
        val.map((item) => item.buildingId)
      )[0];
      this.searchForm.floorId = _.uniq(val.map((item) => item.floorId))[0];
    },

    // 渲染搜索条件和table
    renderPage() {
      this.tmpRuleForm = [
       {
          slot: "mallName"
        },


        {
          slot:'date'
        }
      ];
      this.ruleForm = this.tmpRuleForm.filter((item) => {
        return !item.allowHide;
      });
      this.tableColumns = [
        {
          width: 40,
          type: "selection",
          fixed: true,
        },

        {
         type:'index',
          label: "序号",
          minWidth: "50px",
          // sortable: true,
        },
        {
          prop: "boothCode",
          label: "铺位号",
          minWidth: "120px",
          // sortable: true,
        },
        {
          prop: "buildingName",
          label: "楼栋",
          minWidth: "120px",
          // sortable: true,
        },
        {
          prop: "floorName",
          label: "楼层",
          minWidth: "120px",
          // sortable: true,
        },
        {
          prop: "statementBeginEndTime",
          label: "账单周期",
          minWidth: "120px",
          // sortable: true,
        },
        {
          prop: "paymentDue",
          label: "账单应收日",
          minWidth: "120px",
          // sortable: true,
        },
        {
          prop: "receivableAmount",
          label: "应收金额（元）",
          minWidth: "120px",
          // sortable: true,
        },
        {
          prop: "itemName",
          label: "费用项",
          minWidth: "120px",
          // sortable: true,
        },
        
        {
          slot: "contractCode",
        },
      ];
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../organizationManage/style/index.less";
/deep/ .rs-table__row {
  &:hover {
    cursor: pointer;
  }
}
/deep/ .current-row {
  .resourceCode {
    color: #2ba3ff;
  }
}
.contractCode {
  height: 90px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-around;
   background: #f3f7ff;
}
.contractCode div {
  text-align: center;
  line-height: 2;
  font-size: 16px;
  margin: 5px;
}
.contractCodecolor {
  color: burlywood;
  font-size: 16px;
}
.contractCodecolor span {
  font-size: 14px;
}
.rs-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.bg-purple-dark {
  background-color: #ffffff;
  color: black;
  font-weight: bold;
  font-size: 15px;
  padding-left: 20px;
  display: flex;
  align-items: center;
}
.grid-content {
  /* border-radius: 4px; */
  height: 40px;
  line-height: 40px;
}
.main{
    margin-top: 10px;
    padding: 10px;
}
.container{
  height: 920px;
   background-color: #ebebeb;
}
.main_header{
  background: white;
  padding: 10px;
   box-shadow: 2px 2px 10px #909090;
}
</style>
